import { render } from "./ModalFundAccount.vue?vue&type=template&id=9cb15ac4"
import script from "./ModalFundAccount.vue?vue&type=script&lang=js"
export * from "./ModalFundAccount.vue?vue&type=script&lang=js"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__